import React from 'react';
import { isEmpty, toLower } from 'lodash';
import { LazyLoadImage } from 'react-lazy-load-image-component';
import 'react-lazy-load-image-component/src/effects/blur.css';
import {
  BgLazyImage,
  BottomButton,
  BottomHalf,
  ImageWrapper,
  Container,
  Link,
  Tags,
  TagsContainer,
  Title,
  TopHalf,
  Type,
  VideoWrapper,
  VideoTitle,
  ImageSection,
} from './styles/InsightsCards.styled';
import InsightsContext from '../context/InsightsContext';
import useEllipsis from '../hooks/useEllipsis';
import InsightsCardsInfographics from './InsightsCardsInfographics';

export default function InsightsCards({ data, isSlider, dir }) {
  const { title, tags, cardType, url, featuredImage, imageOverlay } = data;
  const { setSelectedTag } = React.useContext(InsightsContext);

  const ref = useEllipsis(84);

  switch (toLower(cardType)) {
    case 'article':
      return (
        <Container
          hasImage={!isEmpty(featuredImage)}
          isSlider={isSlider}
          className="insights_cardcontainer"
          dir={dir}
        >
          <TopHalf>
            <Type>{cardType}</Type>
            <Title ref={ref}>{title}</Title>
            <TagsContainer>
              {isEmpty(tags) ||
                tags.map(
                  (tag, index) =>
                    index < 3 && (
                      <Tags key={`article_tag_${index}`} onClick={() => setSelectedTag(tag)}>
                        {tag}
                      </Tags>
                    ),
                )}
            </TagsContainer>
          </TopHalf>
          <BottomHalf>
            {isEmpty(featuredImage) || (
              <LazyLoadImage
                width="100%"
                height="100%"
                effect="blur"
                src={featuredImage.url}
                alt={featuredImage.name}
                placeholderSrc={
                  featuredImage.url ? `${featuredImage.url}?width=50&quality=50` : null
                }
              />
            )}
            <BottomButton to={url}>Find Out More</BottomButton>
          </BottomHalf>
        </Container>
      );
    case 'infographic':
      return <InsightsCardsInfographics data={data} isSlider={isSlider} dir={dir} />;
    case 'image':
      return (
        <Container
          hasImage={!isEmpty(featuredImage)}
          isSlider={isSlider}
          overlay
          className={imageOverlay}
        >
          <ImageWrapper>
            <Title white>{title}</Title>
            <TagsContainer>
              {isEmpty(tags) ||
                tags.map(
                  (tag, index) =>
                    index < 3 && (
                      <Tags key={`image_tag_${index}`} onClick={() => setSelectedTag(tag)} white>
                        {tag}
                      </Tags>
                    ),
                )}
            </TagsContainer>
            <ImageSection>
              {isEmpty(featuredImage) || (
                <BgLazyImage
                  width="100%"
                  height="100%"
                  effect="blur"
                  src={featuredImage.url}
                  alt={featuredImage.name}
                  placeholderSrc={
                    featuredImage.url ? `${featuredImage.url}?width=50&quality=50` : null
                  }
                />
              )}
            </ImageSection>

            <Link to={url}>Find Out More</Link>
          </ImageWrapper>
        </Container>
      );
    case 'video':
      return (
        <Container
          hasImage={!isEmpty(featuredImage)}
          isSlider={isSlider}
          overlay
          className={imageOverlay}
        >
          <Link to={url} className="play_button" />
          <VideoWrapper className="banner-video">
            <VideoTitle>{title}</VideoTitle>
            <TagsContainer>
              {isEmpty(tags) ||
                tags.map(
                  (tag, index) =>
                    index < 3 && (
                      <Tags
                        key={`video_tag_${index}`}
                        onClick={() => setSelectedTag(tag)}
                        video
                        white
                      >
                        {tag}
                      </Tags>
                    ),
                )}
            </TagsContainer>
            <ImageSection>
              {isEmpty(featuredImage) || (
                <BgLazyImage
                  width="100%"
                  height="100%"
                  alt={featuredImage.name}
                  placeholderSrc={
                    featuredImage.url ? `${featuredImage.url}?width=50&quality=50` : null
                  }
                  src={featuredImage.url}
                  effect="blur"
                />
              )}
            </ImageSection>

            <Link to={url}>Play Video</Link>
          </VideoWrapper>
        </Container>
      );
    default:
      return null;
  }
}
